import axios from 'axios';
import { CREATE_STEP_TWO } from '../paths';

export const createStep2 = async (data, courseID) => {
  const { trainer, image } = data;
  const body = new FormData();
  body.append('media', image);
  body.append('courseID', courseID);
  body.append('teacherID', trainer._id);
  const response = await axios.post(CREATE_STEP_TWO, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};
